var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"todayTopic"},[_c('SectionTitle',{attrs:{"sectionText":_vm.title,"displayCardCounter":false,"displaySeeMoreText":false}}),_c('div',{staticClass:"article-list"},_vm._l((_vm.infos),function(info,idx){return _c('LatestArticles',{key:idx,attrs:{"idx":idx + 1,"info":info,"staticData":_vm.staticData,"token":_vm.token}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }